// Import model
import { DataviewReportDocumentTemplateResponse } from '../models/DataviewReportDocumentTemplateResponse';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { DataView } from '../models/DataView';
import { FilterReportDocumentTemplateRequest } from '../models/FilterReportDocumentTemplateRequest';
import { ReportDocumentTemplate } from '../models/ReportDocumentTemplate';

// Import dependency serializers (for complex types)
import { DataViewSerializer } from './DataViewSerializer';
import { FilterReportDocumentTemplateRequestSerializer } from './FilterReportDocumentTemplateRequestSerializer';
import { ReportDocumentTemplateSerializer } from './ReportDocumentTemplateSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for DataviewReportDocumentTemplateResponse - handles JSON serialization and deserialization with type validation
 */
export class DataviewReportDocumentTemplateResponseSerializer {
  /**
   * Deserializes a JSON string into a DataviewReportDocumentTemplateResponse instance
   */
  static deserialize(json: string): DataviewReportDocumentTemplateResponse {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a DataviewReportDocumentTemplateResponse instance
   */
  static fromObject(obj: any): DataviewReportDocumentTemplateResponse {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to DataviewReportDocumentTemplateResponse');
    }


    const instance: DataviewReportDocumentTemplateResponse = {
      result: obj['Result'] ? (obj['Result'] as any[]).map((item: any) =>
        ReportDocumentTemplateSerializer.fromObject(item)
      ) : [] as any,
      request: obj['Request'] ? FilterReportDocumentTemplateRequestSerializer.fromObject(obj['Request']) : undefined as any,
      dataView: obj['DataView'] ? DataViewSerializer.fromObject(obj['DataView']) : undefined as any,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of DataviewReportDocumentTemplateResponse instances
   */
  static deserializeArray(json: string): DataviewReportDocumentTemplateResponse[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a DataviewReportDocumentTemplateResponse instance to a JSON string
   */
  static serialize(instance: DataviewReportDocumentTemplateResponse): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a DataviewReportDocumentTemplateResponse instance to a plain object
   */
  static toObject(instance: DataviewReportDocumentTemplateResponse): any {
    return {
      'Result': instance.result?.map((item: any) =>
        ReportDocumentTemplateSerializer.toObject(item)
      ),
      'Request': instance.request ? FilterReportDocumentTemplateRequestSerializer.toObject(instance.request) : undefined,
      'DataView': instance.dataView ? DataViewSerializer.toObject(instance.dataView) : undefined,
    };
  }

  /**
   * Serializes an array of DataviewReportDocumentTemplateResponse instances to a JSON string
   */
  static serializeArray(instances: DataviewReportDocumentTemplateResponse[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
